import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

export const CustomAura = definePreset(Aura, {
    semantic: {
        primary: {
            50: '#5c84c3',
            100: '#5c84c3',
            200: '#5c84c3',
            300: '#5c84c3',
            400: '#5c84c3',
            500: '#5c84c3',
            600: '#5c84c3',
            700: '#5c84c3',
            800: '#5c84c3',
            900: '#5c84c3',
            950: '#5c84c3'
        }
    }
});